import React from 'react';
import { createRoot } from 'react-dom/client';

// import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import { store } from './helpers';

import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './index.css';

// Import the i18n configuration
import './helpers/i18n';

import App from './App';
// import registerServiceWorker from './registerServiceWorker';

const root = createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

//registerServiceWorker();
